export type MarkerType = 'installation' | 'user'

/**
 * Not all possible types that can be returned by Google Geocode API are useful for us regarding user or system locations.
 * E.g. interection, park, etc
 */
export const ACCEPTED_GOOGLE_RESPONSE_TYPES = ['street_address', 'route', 'premise', 'establishment']

export interface CoordinatesRequestData {
  countryCode: string
  streetName?: string
  streetNumber?: string
  // sometimes we have only full address with street name and street number. In this case the address should be taken
  address?: string
  city: string
  zip: string
}

export interface Coordinates {
  latitude: number
  longitude: number
}

export type CoordinateResponse = [coordinates: Coordinates | undefined, geoCodeError: boolean]

export enum CoordinatesError {
  INVALID_RESPONSE,
  SERVICE_DENIED,
  ZERO_RESULTS,
}
